function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { IconButton, TextField } from 'seagull';
import { Edit2Liner18 } from 'seagull/icons';
import { connectControllerToTextField } from "../../../../utils/react-hook-form.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const PackageNameCellContent = _ref => {
  let {
    packageName,
    packageId,
    draft,
    setDraft
  } = _ref;
  const form = useForm({
    mode: 'all',
    defaultValues: {
      packageName
    }
  });
  const _onChange = packageName => {
    if (!packageId) return;
    setDraft(draft.setPackageName(packageId, packageName));
  };
  return /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, form), {}, {
    children: /*#__PURE__*/_jsx(Controller, {
      control: form.control,
      name: "packageName",
      rules: {
        validate: n => !!n && n.length > 0
      },
      render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
        autoFocus: true,
        label: "Package name",
        "data-testid": "edit-package-name-modal",
        onChange: e => {
          _onChange(e.target.value);
          connectControllerToTextField(renderProps).onChange(e);
        }
      }))
    })
  }));
};
export default function EditPackageNameButton(_ref2) {
  let {
    packageName,
    draft,
    packageId,
    onOpenModal
  } = _ref2;
  const onClick = () => {
    onOpenModal({
      width: '400px',
      shouldSubmit: async draft => {
        const bundle = draft.serviceBundles().find(bundle => bundle.id === packageId);
        return Promise.resolve(!!(bundle !== null && bundle !== void 0 && bundle.name) && bundle.name !== packageName);
      },
      renderContent: _ref3 => {
        let {
          setDraft
        } = _ref3;
        return {
          title: 'Package name',
          testid: "edit-package-name-modal",
          onSubmit: defaultBehavior => {
            defaultBehavior();
          },
          content: /*#__PURE__*/_jsx(PackageNameCellContent, {
            packageName: packageName,
            packageId: packageId,
            draft: draft,
            setDraft: setDraft
          })
        };
      }
    });
  };
  return /*#__PURE__*/_jsx(IconButton, {
    "data-testid": "edit-package-name-button-".concat(packageId),
    onClick: onClick,
    children: /*#__PURE__*/_jsx(Edit2Liner18, {})
  });
}